import React, { useEffect } from "react";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: "9999",
    backgroundColor: "#fff",
    overflowY: "auto",
    height: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "80px 0px 0px",
  },
};

export default function Popup(props) {
  useEffect(() => {
    if (props.modalIsOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [props.modalIsOpen]);

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={props.afterOpenModal}
      onRequestClose={props.closeModal}
      style={customStyles}
      contentLabel="Example Modal">
      <img
        src="../../assets/images/bat-img/close.svg"
        onClick={props.closeModal}
        className="popup-close-icon"
      />
      {props.html}
    </Modal>
  );
}
